import { useEffect, useState } from 'react';
import { FilterGroup, CheckboxProps } from '@scale/scaleui';
import _ from 'lodash';

type Props = {
  title: string;
  options: CheckboxProps[];
  setOptions: React.Dispatch<React.SetStateAction<CheckboxProps[]>>;
};

const MMImageServiceAttachmentFilter = ({ title, options, setOptions }: Props) => {
  const selectAllCheckboxOnChange = () => {
    setSelectAllCheckBoxOptions(prevSelectAllOpt => {
      prevSelectAllOpt.checked = !prevSelectAllOpt.checked;
      setOptions(prev => {
        return _.cloneDeep(prev).map(opt => {
          opt.checked = prevSelectAllOpt.checked;

          return opt;
        });
      });
      return prevSelectAllOpt;
    });
  };

  const all_checked = options.every((x: CheckboxProps) => {
    return x.checked;
  });
  const [selectAllCheckBoxOptions, setSelectAllCheckBoxOptions] = useState<CheckboxProps>({
    checked: all_checked,
    name: 'Select All',
    label: 'Select All',
    onChange: selectAllCheckboxOnChange,
  });

  useEffect(() => {
    setSelectAllCheckBoxOptions(prevSelectAllOpt => {
      prevSelectAllOpt.checked = all_checked;
      return prevSelectAllOpt;
    });
  }, [options]);

  return (
    <div className="inline-block">
      <FilterGroup
        title={title}
        checkboxOptions={options}
        masterCheckboxOptions={selectAllCheckBoxOptions}
      />
    </div>
  );
};

export default MMImageServiceAttachmentFilter;
